import { Autocomplete, Box, Chip, TextField, Typography } from '@mui/material';
import { formatDate } from '../utils';
import { OfferConfig } from '../types';

type OfferSelectorProps = {
    offers: OfferConfig[];
    selectedOffer: OfferConfig | null;
    onOfferSelect: (offer: OfferConfig | null) => void;
};

export default function OfferSelector({ offers, selectedOffer, onOfferSelect }: OfferSelectorProps) {
    return (
        <Box>
            <Typography sx={{ color: '#334155', fontSize: '12px', fontWeight: 500, lineHeight: '14px', marginBottom: '4px' }}>
                Select Offer
            </Typography>
            <Autocomplete
                options={offers}
                value={selectedOffer}
                size="small"
                onChange={(_, value) => onOfferSelect(value)}
                getOptionLabel={(option) => option.offer_name}
                isOptionEqualToValue={(option, value) => option.offer_id === value.offer_id}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        placeholder="Select an offer"
                        size="small"
                        sx={{ '& .MuiOutlinedInput-root': { borderRadius: '10px' } }}
                    />
                )}
                renderOption={(props, option) => (
                    <Box component="li" {...props} sx={{ alignItems: 'center', display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                        <Box>
                            <Typography sx={{ fontSize: '14px', fontWeight: 500, color: '#0f172a' }}>
                                {option.offer_name}
                            </Typography>
                            <Typography sx={{ color: '#64748b', fontSize: '12px', lineHeight: '16px' }}>
                                {option.brand} | {formatDate(option.valid_from, option.valid_from_time)} - {formatDate(option.valid_till, option.valid_till_time)}
                            </Typography>
                        </Box>
                        <Chip
                            size="small"
                            label={option.is_active ? 'Active' : 'Inactive'}
                            color={option.is_active ? 'success' : 'default'}
                            variant={option.is_active ? 'filled' : 'outlined'}
                        />
                    </Box>
                )}
            />
        </Box>
    );
}
